module.exports = __webpack_public_path__ + "img/award (11).7ee10b7e.jpg";